import { TEditorOnChange } from 'com/Editor/Editor/interface';
import { useStableCallback } from 'core/hooks/useStableCallback';

export function useOnPaste(onChange: TEditorOnChange) {
  return useStableCallback(async () => {
    const text =
      (await navigator.clipboard.readText()) ?? 'Cannot read clipboard';
    const [question, ...options] = text
      .split('\n')
      .map(str => str.trim())
      .filter(Boolean);

    if (question) {
      onChange({ name: 'question', value: question });
    }

    for (const [idx, option] of options.entries()) {
      onChange({ name: `options.${idx}`, value: option });
    }
  });
}
